import { isExecutive, isReportingManager, type Role } from "@packages/core/session/roles.ts";

export const TEAM_ACCESS: readonly Role[] = [isReportingManager, isExecutive];
